module.exports = __webpack_public_path__ + "static/media/candle_2.655c0056.JPG";